import { SingleUnitGetTargetQuery$data } from '../graphQLOperations/__generated__/SingleUnitGetTargetQuery.graphql';
import { DropdownItemModel } from '../pages/SingleUnit';

type UnitSkills = SingleUnitGetTargetQuery$data;

export const getStandardsInUnit = (allSkillsByUnit: UnitSkills | null): DropdownItemModel[] => {
  const byId = new Map<string, string>();

  allSkillsByUnit?.target?.targetSkills?.forEach(targetSkill => {
    targetSkill?.skill?.standards?.forEach(standard => {
      if (standard?.id && !byId.has(standard.id)) {
        byId.set(standard.id, standard.shortName ?? standard.id);
      }
    });
  });

  return [...byId.entries()]
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));
};

const skillMatchesStandards = (standardIds: string[], selectedStandardIds: string[]): boolean =>
  standardIds.some(id => selectedStandardIds.includes(id));

export const filterSkillsByStandards = (
  selectedStandardIds: string[] | undefined,
  allSkillsByUnit: UnitSkills,
): UnitSkills => {
  if (!selectedStandardIds?.length) return allSkillsByUnit;

  const targetSkills = allSkillsByUnit?.target?.targetSkills?.filter(targetSkill =>
    skillMatchesStandards(
      (targetSkill?.skill?.standards ?? []).map(standard => standard?.id).filter((id): id is string => !!id),
      selectedStandardIds,
    ),
  );

  return {
    ...allSkillsByUnit,
    target: {
      ...allSkillsByUnit.target,
      targetSkills,
    },
  } as UnitSkills;
};
